<template>
  <div :class="classes">
    <div class="trbo-a-spinner__gradient" />
    <div class="trbo-a-spinner__inner" />
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: ''
    }
  },
  computed: {
    classes () {
      return {
        'trbo-a-spinner': true,
        'trbo-a-spinner--small': this.size === 'small'
      }
    }
  }
}
</script>

<style scoped src="./spinner.scss" />
